﻿import $ from 'jquery';

export function initialize(element) {
    $(element).tooltip()
}